export type NumberedBoolean = 0 | 1;

export type Entries<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];

export const toNumberedBoolean = (a: NumberedBoolean | boolean): NumberedBoolean => (a ? 1 : 0);
